<template>
  <div class="waw-outcome waw-outcome--live">
    <div class="waw-outcome__icon">&#x2713;</div>
    <div class="waw-outcome__body">
      <p class="waw-outcome__lead">
        Everything is set up. Your patients can message you on WhatsApp from now on.
      </p>
      <p class="waw-outcome__note">
        Don&rsquo;t see WhatsApp in your reply options? Log out and back in.
      </p>
    </div>
  </div>
</template>

<script>
/**
 * Terminal screen — WhatsApp is on.
 *
 * What a practice needs from this screen (where their messages appear, how to reply on WhatsApp,
 * and what changes for their appointment reminders) is in the copy trio, rendered by the frame.
 * What is left here is the one operational detail that has generated real support contacts: the
 * reply option only appears after a fresh login, because the capability is read at sign-in. It is
 * carried over word-for-word from the tab's live card rather than reworded.
 */
export default {
  name: 'WizardLiveStep',
};
</script>

<style lang="scss" scoped>
@import '../../PatientPayments/tokens';

.waw-outcome {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.waw-outcome__icon {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: $pp-radius-sm;
  background: $pp-brand-subtle;
  font-size: 1.35rem;
  line-height: 1;
}

/* WhatsApp's own brand green — it identifies the channel, so it stays as-is. */
.waw-outcome--live .waw-outcome__icon {
  background: #25d366;
  color: #fff;
  font-weight: 700;
}

.waw-outcome__body {
  flex: 1 1 auto;
  min-width: 0;
}

.waw-outcome__lead {
  margin: 0 0 0.6rem;
  color: $pp-text-strong;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.6;
}

.waw-outcome__note {
  margin: 0;
  padding: 0.6rem 0.8rem;
  border-radius: $pp-radius-sm;
  background: $pp-surface-sunken;
  color: $pp-text-muted;
  font-size: 0.83rem;
  line-height: 1.6;
}
</style>
